import { useEffect, useState } from 'react'

import { useNetworkDebugSource } from 'shared/lib/networkDebug'

import {
  type AcknowledgmentPartnerInfo,
  fetchAcknowledgmentPartnerInfo,
} from '../api/fetchAcknowledgmentPartnerInfo'

import type { AcknowledgmentOffering } from './types'

const EMPTY_PARTNER_INFO: AcknowledgmentPartnerInfo = { isGlobal: false, warningMessage: '' }

type UseAcknowledgmentPartnerInfoParams = {
  partnerId: string
  fYear: number
  programType: AcknowledgmentOffering
}

/** `null` while the record is being read; a failed read leaves the signing steps without it. */
export const useAcknowledgmentPartnerInfo = ({
  partnerId,
  fYear,
  programType,
}: UseAcknowledgmentPartnerInfoParams) => {
  const debugSource = useNetworkDebugSource()
  const [partnerInfo, setPartnerInfo] = useState<AcknowledgmentPartnerInfo | null>(null)

  useEffect(() => {
    if (!partnerId || !fYear || programType === '') {
      setPartnerInfo(EMPTY_PARTNER_INFO)
      return
    }

    let isCurrent = true
    setPartnerInfo(null)

    fetchAcknowledgmentPartnerInfo({ partnerId, fYear, programType, debugSource })
      .catch(() => EMPTY_PARTNER_INFO)
      .then((info) => {
        if (isCurrent) {
          setPartnerInfo(info)
        }
      })

    return () => {
      isCurrent = false
    }
  }, [partnerId, fYear, programType, debugSource])

  return partnerInfo
}
